import { useMemo } from "react";
import {
  isNavItemVisible,
  userCanAccessPath,
  userHasAnyPermission,
} from "../lib/permissions";
import { useAuthStore } from "../stores/authStore";

export function usePermissions() {
  const user = useAuthStore((s) => s.user);

  return useMemo(
    () => ({
      user,
      canAccessPath: (pathname: string) => userCanAccessPath(user, pathname),
      hasAnyPermission: (codes: string[]) => userHasAnyPermission(user, codes),
      isNavItemVisible: (href: string, options?: { adminOnly?: boolean }) =>
        isNavItemVisible(user, href, options),
    }),
    [user],
  );
}
